import ConfirmDiscardUnsavedMetaDataModal from '../../MetaData/Modals/ConfirmDiscardUnsavedMetaDataModal';

export const DiscardTagsChangesPrompt = ConfirmDiscardUnsavedMetaDataModal;
